/**
 * Storage yang menelan exception private-mode (Safari private, iframe tanpa izin).
 * Diakses lewat getter supaya mock di tes terpasang setelah impor tetap terpakai.
 */
export const safeStorage = (kind: "local" | "session" = "local") => {
  const s = () => (kind === "local" ? localStorage : sessionStorage);
  return {
    get: (k: string): string | null => {
      try {
        return s().getItem(k);
      } catch {
        return null;
      }
    },
    set: (k: string, v: string) => {
      try {
        s().setItem(k, v);
      } catch {
        /* private mode: nilai hanya bertahan selama halaman terbuka */
      }
    },
    remove: (k: string) => {
      try {
        s().removeItem(k);
      } catch {
        /* abaikan */
      }
    },
  };
};

const store = safeStorage();
const key = (slug: string) => `token:${slug}`;

export const readToken = (slug: string) => store.get(key(slug));
export const writeToken = (slug: string, token: string) => store.set(key(slug), token);
export const clearToken = (slug: string) => store.remove(key(slug));
